export class Controller {

    /** @ngInject */
    constructor(CompanyUserResource) {
        this.CompanyUserResource = CompanyUserResource;
    }

    $onInit() {
        this.initCompanyRoles();
        this.initUserRoles();
    }

    companyRoleIconClass(role) {
        return ({
            'APPLICATION_ADMIN': 'fa fa-list-alt',
            'DEVELOPER_ADMIN': 'fa fa-wrench',
            'ORGANIZATION_ADMIN': 'fa fa-sitemap',
            'READ_ONLY_ADMIN': 'fa fa-eye',
            'SUPER_ADMIN': 'fa fa-building',
            'SAASPASS_ADMIN': 'fa fa-building',
        })[role];
    }

    onUserCompaniesDropdownToggle() {
        this.userCompaniesDropdownSearchKey = '';
    }

    logAdminDevSwitchToCompany(companyId) {
      this.$rootScope.logCompanyAccessed$ =  this.CompanyUserResource
            .logCompanyAccessed(companyId)
    }

    /** @private */
    initCompanyRoles() {

        const role = this.currentCompany.authoritiesConstants;
        const hasRole = (...roles) => ['SAASPASS_ADMIN', 'SUPER_ADMIN', 'READ_ONLY_ADMIN', ...roles].includes(role);

        this.canView = {
            'reseller': hasRole(),

            'saaspass-admin': role === 'SAASPASS_ADMIN',
            'directory-services': hasRole('ORGANIZATION_ADMIN'),
            'directory-groups': hasRole('ORGANIZATION_ADMIN'),
            'saaspass-users': hasRole(),
            'directory-integration': hasRole(),

            'applications-group': hasRole('APPLICATION_ADMIN', 'DEVELOPER_ADMIN'),
            'applications': hasRole('APPLICATION_ADMIN'),
            'sharing-center': hasRole(),
            'hard-token-management': hasRole(),
            'computer-protection': hasRole('APPLICATION_ADMIN'),
            'slack-info': hasRole(),
            'google-marketplace-instructions': hasRole(),
            'custom-app-integration': hasRole('DEVELOPER_ADMIN'),
            'saaspass-connect': hasRole('DEVELOPER_ADMIN'),

            // 'saaspass-vpn': hasRole('DEVELOPER_ADMIN'),
            'saaspass-vpn': false,
            
            'sms-services': hasRole(),
            'policies': hasRole(),

            'recovery': hasRole(),
            'administrators': hasRole(),
            'reports-main': hasRole(),
            'corporate-settings': hasRole(),
            'domains': hasRole(),
        };
    }

    /** @private */
    initUserRoles() {
        this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
    }

    isReseller() {
        return this.currentCompany.companyType === 'RESELLER';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/company.controller.js